import Model, { belongsTo, attr } from '@ember-data/model'
import { Type } from '@warp-drive/core-types/symbols'
import type Teacher from 'teacher-ui-client/models/teacher'

export interface Preferences {
  teacher_home_enabled: boolean
  // Stored widget ids may contain stale values when widgets are removed from the app.
  widgets: string[]
}

export default class DashboardPreferences extends Model {
  @attr() declare preferences: Preferences

  @belongsTo<Teacher>('teacher', { async: false, inverse: 'dashboardPreferences' })
  declare teacher: Teacher;

  [Type] = 'dashboard-preferences' as const
}
